import React from 'react';
import { Backdrop, Box } from '@mui/material';
import { Loader } from '@care/react-component-lib';
import { HEIGHT_MINUS_TOOLBAR } from '@/constants';
import { SxClassProps } from '@/types/common';

const classes: SxClassProps = {
  backdrop: {
    '&.MuiBackdrop-root': {
      zIndex: 5,
      backgroundColor: 'transparent',
      height: `${HEIGHT_MINUS_TOOLBAR}`,
      left: '-5px',
      right: '-5px',
    },
  },
  container: {
    height: `${HEIGHT_MINUS_TOOLBAR}`,
  },
};

interface OverlaySpinnerProps {
  isOpen?: boolean;
  wrapped?: boolean;
}

function OverlaySpinner(props: OverlaySpinnerProps) {
  const { isOpen = false, wrapped, ...rest } = props;
  const backdrop = (
    <Backdrop sx={classes.backdrop} open={isOpen} {...rest}>
      <Loader />
    </Backdrop>
  );
  if (wrapped) {
    return <Box sx={classes.container}>{backdrop}</Box>;
  }
  return <>{backdrop}</>;
}
OverlaySpinner.defaultProps = {
  isOpen: false,
  wrapped: false,
};

export default OverlaySpinner;
